import { DeleteFilled } from "@ant-design/icons";
import "./icon.scss";

export function DeleteIcon() {
  return <DeleteFilled className="icon" />;
}
